import { createI18n } from '@learnforge/i18n';
import { locales, type FuncKey } from './locales';

export const i18n = createI18n<FuncKey>({
  gameId: 'functions',
  locales,
});
